// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportConfigurationRecurrent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportConfigurationRecurrent component
 */
!(function() {
  var React = require('react');
  var classnames = require('classnames');
  var EventsUtils = require('EventUtils');
  var connect = require('share/enhancers/Izenda.Connect');

  var moment = require('moment');
  var momentTimezone = require('moment-timezone');

  var actions = require('./Izenda.ReportConfigurationAction');
  var Input = require('share/components/controls/Izenda.Input');
  var NumericInput = require('share/components/controls/Izenda.NumericInput');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var DateTimePicker = Validator()(require('share/components/controls/DateTime/Izenda.DateTimePicker'));
  var constants = require('logic/data/Izenda.OtherSettingsConstants');

  var RecurrenceTime = connect()(function(props) {
    var model = props.model;
    var recurrentSetting = model.recurrentReportSetting;
    var recurrenceType = model.recurrentReportSetting.recurrenceType;
    var disabledNumberInput = (recurrenceType !== props.type) || recurrentSetting.once;

    return (
      <div>
        <label>
          <Input
            type="radio"
            checked={recurrenceType === props.type}
            disabled={recurrentSetting.once}
            onChange={EventsUtils.notifyChange(model.setRecurrenceType.bind(model, props.type), EventsUtils.RADIO)} />
          Every
        </label>
        <NumericInput
          min={constants.ARCHIVED_VERSIONS_MIN_VALUE}
          max={constants.ARCHIVED_VERSIONS_MAX_VALUE}
          disabled={disabledNumberInput}
          value={disabledNumberInput ? null : model.recurrentReportSetting.occurValue}
          onChange={model.setValueByKey.bind(model, "occurValue")} />
        <label>
          {props.labelType}
        </label>
      </div>
    );
  });

  var ReportConfigurationRecurrent = React.createClass({
    render: function() {
      var props = this.props;
      var model = props.store.reportConfiguration;
      var recurrentSetting = model.recurrentReportSetting;

      return (
        <GridLayout.Col cols="9">
          <GridLayout.Row>
            <GridLayout.Col cols="2">
              <div className="radio">
                <label>
                  <Input
                    type="radio"
                    name="optradio"
                    checked={recurrentSetting.once}
                    onChange={EventsUtils.notifyChange(model.setTypeArchived.bind(model, "once"), EventsUtils.RADIO)} />
                  Once
                </label>
              </div>
            </GridLayout.Col>
            <GridLayout.Col cols="5">
              <span>At Date</span>
              <DateTimePicker
                field="atDate"
                validations={recurrentSetting.once ? constants.requiredConstraints("At Date") : {}}
                containerClassName="izenda-ReportConfiguration-control"
                time={false}
                disabled={!recurrentSetting.once}
                value={recurrentSetting.atDate}
                onChange={model.setValueByKey.bind(model, "atDate")}
              />
            </GridLayout.Col>
            <GridLayout.Col cols="5">
              <span>At Time</span>
              <DateTimePicker
                field="atTime"
                validations={recurrentSetting.once ? constants.requiredConstraints("At Time") : {}}
                containerClassName="izenda-ReportConfiguration-control"
                calendar={false}
                disabled={!recurrentSetting.once}
                value={momentTimezone(recurrentSetting.atTime)}
                onChange={props.onChangeTime.bind(props, "atTime")}
              />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row>
            <GridLayout.Col cols="2">
              <div className="radio">
                <label>
                  <Input
                    type="radio"
                    name="optradio"
                    checked={recurrentSetting.recurrence}
                    onChange={EventsUtils.notifyChange(model.setTypeArchived.bind(model, "recurrence"), EventsUtils.RADIO)} />
                  Recurrence
                </label>
              </div>
            </GridLayout.Col>
            <GridLayout.Col cols="5">
              <span>Start Date</span>
              <DateTimePicker
                field="startDate"
                validations={recurrentSetting.recurrence ? constants.requiredConstraints("Start Date") : {}}
                containerClassName="izenda-ReportConfiguration-control"
                time={false}
                disabled={!recurrentSetting.recurrence}
                value={recurrentSetting.startDate}
                onChange={model.setValueByKey.bind(model, "startDate")}
              />
            </GridLayout.Col>
            <GridLayout.Col cols="5">
              <span>Start Time</span>
              <DateTimePicker
                field="startTime"
                validations={recurrentSetting.recurrence ? constants.requiredConstraints("Start Time") : {}}
                containerClassName="izenda-ReportConfiguration-control"
                calendar={false}
                disabled={!recurrentSetting.recurrence}
                value={momentTimezone(recurrentSetting.startTime)}
                onChange={props.onChangeTime.bind(props, "startTime")}
              />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row>
            <GridLayout.Col cols="5" offset="2">
              <RecurrenceTime model={model} type={0} labelType="day(s)" />
            </GridLayout.Col>
            <GridLayout.Col cols="5">
              <RecurrenceTime model={model} type={1} labelType="week(s)" />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row>
            <GridLayout.Col cols="5" offset="2">
              <RecurrenceTime model={model} type={2} labelType="month(s)" />
            </GridLayout.Col>
            <GridLayout.Col cols="5">
              <RecurrenceTime model={model} type={3} labelType="year(s)" />
            </GridLayout.Col>
          </GridLayout.Row>
        
        </GridLayout.Col>
      );
    }
  });

  module.exports = connect(actions)(ReportConfigurationRecurrent);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Report/Izenda.ReportConfigurationRecurrent.jsx